export default __webpack_public_path__ + "static/media/send.11bbbc11.svg";